import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { EventWriteDTO, EventViewDTO } from '../interfaces/event';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(private dataService: DataService) { }

  getUpcomingEvents(calendarId: number): Observable<EventViewDTO[]> {
    return this.dataService.getUpcomingEvents(calendarId);
  }

  getEventsInRange(calendarId: number, startDate: Date, endDate: Date) {
    const startISO = startDate.toISOString();
    const endISO = endDate.toISOString();
    return this.dataService.getEventsInRange(calendarId, startISO, endISO);
  }

  getDashboardOverview(startDate: Date, endDate: Date) {
    const startISO = startDate.toISOString();
    const endISO = endDate.toISOString();
    return this.dataService.getDashboardOverview(startISO, endISO);
  }

  getEventsByHours(calendarId: number, startDate: Date, lookbackHours: number, outlookHours: number) {
    const startRange = new Date(startDate.getTime());
    startRange.setHours(startRange.getHours() - lookbackHours);

    const endRange = new Date(startDate.getTime());
    endRange.setHours(endRange.getHours() + outlookHours);

    const startISO = startRange.toISOString();
    const endISO = endRange.toISOString();

    return this.dataService.getEventsInRange(calendarId, startISO, endISO);
  }

  addEvent(event: EventWriteDTO): Observable<EventViewDTO> {
    return this.dataService.addEvent(event);
  }

  updateEvent(id: number, scope: string, event: EventWriteDTO): Observable<EventViewDTO> {
    return this.dataService.updateEvent(id, scope, event);
  }

  deleteEvent(id: number, scope: string, occurrenceDate?: string): Observable<void> {
    return this.dataService.deleteEvent(id, scope, occurrenceDate);
  }
}
